import DBOperationsComb from "src/utils/dbOperationsComb";
import Exception from "src/utils/exception";

async function getEmployeeList(tableName, config) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName,
        sortField: "displayName",
        sortOrder: 1,
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getEmployeeList
};
